import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { provideInfoContextKey_Expression, provideInfoContextKey_Protocol, provideInfoContextKey_Score } from '../../../../../modules/provide-info/types.js';
import { Component_ProvideInfoV2_Protocol } from '../Component_ProvideInfoV2_Protocol/Component_ProvideInfoV2_Protocol.js';
import { Component_ProvideInfoV2_Expression } from '../Component_ProvideInfoV2_Expression/Component_ProvideInfoV2_Expression.js';
import { Component_ProvideInfoV2_Score } from '../Component_ProvideInfoV2_Score/Component_ProvideInfoV2_Score.js';
import './Component_ProvideInfo_V2.scss';
export class Component_ProvideInfo_V2 extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.context = nextProps.context;
        return state;
    }
    //######################### Render #########################
    render() {
        return _jsx(LL_V_L, { className: 'provide-info-body', children: this.render_Content() });
    }
    render_Content = () => {
        const context = this.state.context;
        switch (context?.key) {
            case provideInfoContextKey_Protocol:
                return _jsx(Component_ProvideInfoV2_Protocol, { contextData: context.data });
            case provideInfoContextKey_Expression:
                return _jsx(Component_ProvideInfoV2_Expression, { contextData: context.data });
            case provideInfoContextKey_Score:
                return _jsx(Component_ProvideInfoV2_Score, { contextData: context.data });
            default:
                return _jsx(_Fragment, {});
        }
    };
}
//# sourceMappingURL=Component_ProvideInfo_V2.js.map